export default __webpack_public_path__ + "static/media/3_acigroup.0c755fc1.svg";